
import defaultUI from "./ui/default/default";
export default defaultUI;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui.js
// module id = 1417
// module chunks = 2